/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosports4ColumnImagesViewProps } from '../../../modules/hosports-4-column-images/./hosports-4-column-images';
import FullWidthImage from '../../../baseComponents/full-width-image/./full-width-image';
import GridStructure from '../../../baseComponents/grid-structure/./grid-structure';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';

export default (props: IHosports4ColumnImagesViewProps) => {
  let config = props.config;

  return (
    <ScrollFadeIn>
      <div className="site-gutter">
        <GridStructure
          columns={4}>
          <FullWidthImage
            image={config.image1 ? config.image1.src : undefined}
            height={config.height}
          />
          <FullWidthImage
            image={config.image2 ? config.image2.src : undefined}
            height={config.height}
          />
          <FullWidthImage
            image={config.image3 ? config.image3.src : undefined}
            height={config.height}
          />
          <FullWidthImage
            image={config.image4 ? config.image4.src : undefined}
            height={config.height}
          />
        </GridStructure>
      </div>
    </ScrollFadeIn>
  );
};
